import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import "./admin-reservation.scss";
import { TourListHistory, ActiveTourList, ToursTab } from "./Tabs";
import EditModals from "./Modals";

import { findRecord } from "services/services";

export default function Index() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    findRecord("users", {
      fields: "id, fname, lname, mobile",
      conditions: "fname/!=/@@lname/!=/@@mobile/!=/@@codemelli/!=/",
    }).then((res) => {
      setUsers(res);
    });
  }, []);

  return (
    <div className="admin-reservation-container px-sm-3 w-100">
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#active-tour-list" type="button" role="tab" aria-controls="home" aria-selected="true">
            لیست رزرو تورهای فعال
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#tour-list-history" type="button" role="tab" aria-controls="profile" aria-selected="false">
            سابقه
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="" data-bs-toggle="tab" data-bs-target="#tours-tab" type="button">
            تور ها
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <ActiveTourList />
        <TourListHistory />
        <ToursTab />
      </div>
      {ReactDOM.createPortal(<EditModals users={users} tour={{price: 1000000, discount: 100000}} />, document.querySelector(".modals"))}
    </div>
  );
}
